import { useRuntimeConfig } from "#imports";
import { createGtm } from "@gtm-support/vue-gtm";

export default defineNuxtPlugin(async (nuxtApp) => {
  if (import.meta.env.STORYBOOK) return;
  const { public: config } = useRuntimeConfig();

  nuxtApp.vueApp.use(
    createGtm({
      id: config.gtm.id,
      enabled: config.gtm.enabled,
    }),
  );
});
